import React from 'react'
import Container from '../../../components/Admin/Container/Container'
import Add from '../../../components/Admin/AddUser/Add'

export default function AddUser() {
  return (
    <Container>
        <Add/>
    </Container>
  )
}
